import dependencies from "../authentication/dependencies";
import { formatApiError } from "../constants/apiErrorMessages";
import v4 from "uuid/v4";
const { baseUrl, newBaseUrl, generalHeader } = dependencies;

export const createGoLive = async (csrfToken, data, userId) => {
  const url = newBaseUrl + "/GoLive/create";

  const payload = {
    header: {
      id: v4(),
      application: data.applicationId || v4(),
      bank: "NBG",
      userId: userId || v4(),
    },
    payload: {
      title: data.title,
      address: data.address,
      applicationId: data.applicationId,
      companyName: data.companyName,
      goLiveDeveloperTypeId: data.goLiveDeveloperTypeId,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      siteUrlDownloadLocation: data.siteUrlDownloadLocation,
      useCases: data.useCases,
      urlAlias: data.urlAlias,
      langcode: data.langcode,
      status: data.status,
      sticky: data.sticky,
      promote: data.promote,
      published: data.published,
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: generalHeader(csrfToken),
    credentials: "include",
    body: JSON.stringify(payload),
  });

  // A gateway error (e.g. 504 when a backend check takes too long) comes back as an HTML page,
  // and parsing it as JSON showed the user "Unexpected token '<'...".
  let responseData;
  try {
    responseData = await res.json();
  } catch {
    throw new Error(
      res.status === 502 || res.status === 503 || res.status === 504
        ? "The service did not respond in time. Please try again in a few minutes."
        : "Failed to create Go Live request. Please try again later."
    );
  }

  // Check if there's an exception in the response
  if (
    responseData.exception &&
    Object.keys(responseData.exception).length > 0
  ) {
    throw new Error(formatApiError(responseData.exception));
  }

  if (!res.ok) {
    throw new Error("Failed to create Go Live request");
  }

  return responseData;
};

export const getGoLive = async (csrfToken, id, applicationId, userId) => {
  const url = newBaseUrl + "/GoLive/get";

  const payload = {
    header: {
      id: v4(),
      application: applicationId || v4(),
      bank: "NBG",
      userId: userId || v4(),
    },
    payload: {
      id: id,
      applicationId: applicationId,
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: generalHeader(csrfToken),
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const updateGoLive = async (csrfToken, data, userId) => {
  const url = newBaseUrl + "/GoLive/update";

  const payload = {
    header: {
      id: v4(),
      application: data.applicationId || v4(),
      bank: "NBG",
      userId: userId || v4(),
    },
    payload: {
      id: data.id,
      title: data.title,
      address: data.address,
      applicationId: data.applicationId,
      companyName: data.companyName,
      goLiveDeveloperTypeId: data.goLiveDeveloperTypeId,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      siteUrlDownloadLocation: data.siteUrlDownloadLocation,
      useCases: data.useCases,
      urlAlias: data.urlAlias,
      langcode: data.langcode,
      status: data.status,
      sticky: data.sticky,
      promote: data.promote,
      published: data.published,
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: generalHeader(csrfToken),
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const deleteGoLive = async (csrfToken, id, userId) => {
  const url = newBaseUrl + "/GoLive/delete";

  const payload = {
    header: {
      id: v4(),
      application: v4(),
      bank: "NBG",
      userId: userId || v4(),
    },
    payload: {
      id: id,
      fieldsToDelete: [],
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: generalHeader(csrfToken),
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const listGoLiveForms = async (
  csrfToken,
  userId,
  pageLimit = 50,
  pageOffset = 0,
  sortField = "created",
  sortOrder = "desc"
) => {
  const url = newBaseUrl + "/GoLive/list";

  const payload = {
    header: {
      id: v4(),
      application: v4(),
      bank: "NBG",
      userId: userId || v4(),
    },
    payload: {
      pageLimit: pageLimit,
      pageOffset: pageOffset,
      sortField: sortField,
      sortOrder: sortOrder,
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: generalHeader(csrfToken),
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const listGoLiveDeveloperTypes = async (
  csrfToken,
  userId,
  pageLimit = 50,
  pageOffset = 0
) => {
  const url = newBaseUrl + "/GoLiveDeveloperType/list-public";

  const payload = {
    header: {
      id: v4(),
      application: v4(),
      bank: "NBG",
      userId: userId || v4(),
    },
    payload: {
      pageLimit: pageLimit,
      pageOffset: pageOffset,
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: generalHeader(csrfToken),
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return res.json();
};
